exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover,.whiteOnHover{color:#fff!important}", ""]);

// exports
